import { FaLine } from "react-icons/fa";
import { useTheme } from '../contexts/ThemeContext';

const Line = () => {
  const { theme } = useTheme();

  const getLineStyles = () => {
    if (theme === 'modern') {
      return "w-[80%] mt-16 mb-8 text-center modern-divider border-t pt-8";
    }
    return "w-[60%] mt-20 text-center border-t-2 border-black pt-8";
  };

  return (
    <FaLine className={getLineStyles()} />
  )
}

export default Line;